import React from 'react'
import { useTranslation } from 'react-i18next'
import GenericStatsDetails from './GenericStatsDetails'

const OrderLines: React.FC = () => {
  const { t } = useTranslation()

  return <GenericStatsDetails entity='orderRow' entityTranslation={t('global.stats.orderlines')} icon='dolly flatbed' />
}

export default OrderLines
